module.exports = __webpack_public_path__ + "img/bg-1.1ad4c6d6.png";